<template>
  <AppDialog
    class="member-profile-field-dialog"
    title="Delete custom field?"
    subtitle="This field and all of the information in it will be deleted. This includes information from ALL MEMBERS' profiles. This action cannot be undone."
    append-to-body
    show
    @close="closeDialog"
  >
    <form
      id="delete-member-profile-field-form"
      autocomplete="off"
      @submit.prevent="onFormSubmit"
    />

    <template id="footer">
      <div class="d-flex">
        <div class="ml-auto">
          <AppButton
            class="mr-15"
            type="default"
            @click="closeDialog"
          >
            Cancel
          </AppButton>

          <button
            class="btn btn-danger"
            type="submit"
            form="delete-member-profile-field-form"
            :disabled="form.processing"
          >
            Delete
          </button>
        </div>
      </div>
    </template>
  </AppDialog>
</template>
<script>
import { mapInertiaProps } from '@/utils/inertia';
import { applyTemplate } from '@/utils/url_template';

export default {
  name: 'DeleteMemberProfileFieldDialog',
  components: {},
  props: {
    memberProfileField: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: this.$inertia.form({
        key: this.memberProfileField.key,
      }),
    };
  },
  computed: {
    ...mapInertiaProps({
      organization: 'organization',
    }),
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    onFormSubmit() {
      const { origin } = window.location;
      const url = new URL(
        applyTemplate('/organizations/:id/update_member_profile_fields', { id: this.organization.id }),
        origin,
      );
      const organizationsUrlString = url.toString();

      this.form.transform((data) => {
        const payload = {};

        payload.key = data.key;
        payload.remove_field = true;

        return { organization: { member_profile_field: payload } };
      });

      const options = {
        onSuccess: () => {
          this.$appMessage('Member profile field deleted');
          this.$emit('close-edit-dialog');
          this.closeDialog();
        },
      };

      return this.form.post(organizationsUrlString, options);
    },
  },
};
</script>
